import rootReducer from "./rootReduce";
import rootSaga from "./rootSaga";
import createSagaMiddleware from "redux-saga";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import persistStore from "redux-persist/es/persistStore";
// import addressSlice from './device/address';
const persistConfig = {
  key: "ivalinmabia",
  storage,

  whitelist: ["auth", "device"], // Add reducers you want to persist here
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();
// const rootReducerWithAddress = {
//   ...rootReducer,
//   address: addressSlice, // Add addressReducer here
// };
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

const persistor = persistStore(store);
sagaMiddleware.run(rootSaga);

export { store, persistor };
